export default "__VITE_ASSET__bvZm6v3T__"